module.exports = __webpack_public_path__ + "img/MuhammadHamo-NrxWGrngi.b296a42f.jpg";